module.exports = __webpack_public_path__ + "static/img/02_07.4eae014c.jpg";